<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <g>
      <path
        d="M21.986,5.028 L15.986,6.249 L17.702,7.957 L12.351,13.314 L9.35,10.312 L2.014,17.555 L3.424,18.972 L9.346,13.139 L12.337,16.132 L19.118,9.37 L20.785,11.03 L21.986,5.028 z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'RisingArrowIcon',
  };
</script>
